import { combineReducers, applyMiddleware, compose, createStore } from 'redux';
import createRavenMiddleware from 'raven-for-redux';
import AddFillableFieldsReducer from 'Modals/AddFillableFieldsModal/AddFillableFieldsModalReducer';
import { AnimationReducer } from 'Animation';
import IowaBENInputHandler from 'IowaBENInput/IowaBENInputReducer';
import PopupGroupReducer from 'PopupGroup/PopupGroupReducer';
import popupHandler from 'Popups/PopupsReducer';
import RequestSignatureReducer from 'Popups/RequestSignaturePopupWrapper/RequestSignatureReducer';
import SelfServeBuilderResponsesReducer from 'SelfServeBuilderResponses/SelfServeBuilderResponsesReducer';
import { SelfServeBuilderSidePanelHandler } from 'SelfServeBuilderSidePanel';
import { SelfServePostBuilderSidePanelHandler } from 'SelfServePostBuilderSidePanel';
import SendForSignatureToolbarHandler from 'SendForSignatureToolbar/SendForSignatureToolbarReducer';
import SessionListStateHandler from 'SessionList/SessionListReducer';
import SignatureHandler from 'SignatureManager/SignatureReducer';
import StaticBuilderReducer from 'StaticBuilder/StaticBuilderReducer';
import SessionEmailReducer from 'StaticBuilder/SessionEmail/SessionEmailReducer';
import VisualStaticStateHandler from 'VisualStatic/VisualStaticReducer';
import DownloadOverlayHandler from './download-overlay/DownloadOverlayReducer';
import EditorStateHandler from './EditorOverlay/EditorOverlayReducer';
import FormSwiftAPIHandler from './FormSwiftAPI/FormSwiftAPIReducer';
import FreeWriteBuilderModalHandler from './FreeWriteBuilderModals/FreeWriteBuilderModalReducer';
import ModalHandler from './Modals/ModalReducer';
import PDFPageEditorOptInPanelReducer from './PDFPageEditorOptInPanel/PDFPageEditorOptInPanelReducer';
import PDFPageEditorReducer from './PDFPageEditor/PDFPageEditorReducer';
import PDFViewerReducer from './PDFViewer/PDFViewerReducer';
import RulerToolReducer from './RulerTool/RulerToolReducer';
import SelfServeBuilderReducer from './SelfServeBuilder/SelfServeBuilderReducer';
import SelfServeBuilderToolboxReducer from './SelfServeBuilderToolbox/SelfServeBuilderToolboxReducer';
import SidebarSiteNavigationReducer from './SidebarSiteNavigation/SidebarSiteNavigationReducer';
import SignatureAuditButtonReducer from './SignatureAuditButton/SignatureAuditButtonReducer';
import SignatureStateToolbarReducer from './SignatureStateToolbar/SignatureStateToolbarReducer';
import StaticBuilderModalHandler from './StaticBuilderModals/StaticBuilderModalReducer';
import TabbedToolbarReducer from './TabbedToolbar/reducer';
import ToolboxTooltipTourReducer from './SelfServeTooltipTour/ToolboxTooltipTourReducer';
import TooltipTourReducer from './SelfServeTooltipTour/TooltipTourReducer';
import UploadHandler from './Upload/UploadReducer';
import VisualStaticLoadingModalReducer from './Modals/VisualStaticLoadingModal/VisualStaticLoadingModalReducer';

export const thunkMiddleware = state => next => (action) => {
  if (typeof (action) === 'function') {
    return action(state.dispatch, state.getState);
  }
  return next(action);
};

function textareaHandler(state, action) {
  if (typeof state === 'undefined') {
    return {
      bold: false,
      italic: false,
      fontFamily: 'Arial',
      fontSize: 17,
    };
  }

  switch (action.type) {
    case 'UPDATE_TEXTAREA_STATE':
      return Object.assign({}, state, action.attributes);
    default:
      return state;
  }
}

export const appReducer = combineReducers({
  AddFillableFieldsReducer,
  AnimationReducer,
  DownloadOverlayHandler,
  EditorStateHandler,
  FormSwiftAPIHandler,
  FreeWriteBuilderModalHandler,
  IowaBENInputHandler,
  ModalHandler,
  PDFPageEditorOptInPanelReducer,
  PDFPageEditorReducer,
  PDFViewerReducer,
  PopupGroupReducer,
  popupHandler,
  RequestSignatureReducer,
  RulerToolReducer,
  SelfServeBuilderReducer,
  SelfServeBuilderResponsesReducer,
  SelfServeBuilderSidePanelHandler,
  SelfServeBuilderToolboxReducer,
  SelfServePostBuilderSidePanelHandler,
  SendForSignatureToolbarHandler,
  SessionEmailReducer,
  SessionListStateHandler,
  SidebarSiteNavigationReducer,
  SignatureAuditButtonReducer,
  SignatureHandler,
  SignatureStateToolbarReducer,
  StaticBuilderReducer,
  StaticBuilderModalHandler,
  TabbedToolbarReducer,
  textareaHandler,
  ToolboxTooltipTourReducer,
  TooltipTourReducer,
  UploadHandler,
  VisualStaticLoadingModalReducer,
  VisualStaticStateHandler,
});

const middlewares = [
  // Raven must be the first middleware listed
  ...(
    typeof window.Raven !== 'undefined' ? [
      createRavenMiddleware(window.Raven, {
        breadcrumbDataFromAction: action => ({
          ...action,
        }),
      }),
    ] :
    []
  ),
  thunkMiddleware,
];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = composeEnhancers(applyMiddleware(...middlewares))(createStore)(appReducer, {});

export const initStore = () => (
  composeEnhancers(applyMiddleware(...middlewares))(createStore)(appReducer, {})
);

export const getStore = () => store;

export default store;



// WEBPACK FOOTER //
// ./src-react/store.jsx